import{N as ie,P as re,K as oe,A as ne,M as ae,S as le}from"./a11y-DBfGp2de.js";function Y(n,o){if(o===null)return n;if(o==="master")return Z(n);const t=n.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(t){const e=n.split(t[0]),s=t[0];return Z(`${e[0]}_${o}${s}`)}else return null}function Z(n){return n.replace(/http(s)?:/,"")}async function se(n){var o=n.reduce((s,i)=>{var a,l;var r=(l=(a=i.metafields)==null?void 0:a.colour)==null?void 0:l.variations;return r&&(s[i.id]=r.value.split(/\s*,\s*/).map(c=>c.trim()).filter(c=>c.length>0)),s},{}),t=Tagalys.getPlatformConfiguration().storefrontAPI;return await ce(o,t.accessToken,t.myShopifyDomain)}async function ce(n,o,t){const e=`https://${t}/api/2025-04/graphql.json`,s=[...new Set(Object.values(n).flat())],r=`
    query {
      ${s.map((d,p)=>`
    product${p}: product(handle: "${d}") {
      id
      handle
      title
      onlineStoreUrl
      colour_colour: metafield(namespace: "colour", key: "variations") {
        value
      }
      colour_swatch: metafield(namespace: "colour", key: "swatch") {
        value
      }
      metafields(identifiers: [
        {namespace: "colour", key: "swatch"}
        {namespace: "colour", key: "variations"}
      ]) {
        namespace
        key
        value
      }
    }
  `).join(`
`)}
    }
  `,l=await(await fetch(e,{method:"POST",headers:{"Content-Type":"application/json","X-Shopify-Storefront-Access-Token":o},body:JSON.stringify({query:r})})).json(),c={};s.forEach((d,p)=>{const h=l.data[`product${p}`];if(h){const g={};h.metafields&&h.metafields.forEach(v=>{g[v.namespace]||(g[v.namespace]={}),g[v.namespace][v.key]=v.value}),c[d]={...h,metafields:g}}});const u={};return Object.entries(n).forEach(([d,p])=>{u[d]=[],p.forEach(h=>{const g=c[h];g&&u[d].push({id:g.id,handle:g.handle,title:g.title,url:g.onlineStoreUrl,metafields:g.metafields})}),u[d].length===0&&(u[d]=[])}),u}function de(n,o,t,e={}){var r,a;const s=[],i=s.length<2;if(i&&e.prod_new_show&&((r=n.tags)!=null&&r.some(l=>l.toLowerCase()==="new"))&&s.push(t`<div class="product_badge">New</div>`),i&&e.prod_reduction_show&&(o==null?void 0:o.compare_at_price)>(o==null?void 0:o.price)){const l=100-Math.round(o.price/o.compare_at_price*100);s.push(t`<div class="product_badge sale">${l}% OFF</div>`)}if(i){const l=(a=n.tags)==null?void 0:a.find(c=>c.startsWith("Badge:"));if(l){const c=l.split(":").pop().trim();s.push(t`<div class="product_badge">${c}</div>`)}}return s.length?t`<div class="product-label-container">${s}</div>`:""}const $={searchSuggestions:'[data-tagalys-ui-widget="search-suggestions"]',searchSuggestionsInput:"#search_query",searchResults:'[data-tagalys-ui-widget="search-results"]'},N={tagalysNoResults:"search-content--tagalys-no-results",tagalysHasResults:"search-content--tagalys-has-results"};let H=[];class ue{constructor(o){this.element=o,this.open=!1,this.button=o.querySelector(".link-dropdown__button"),this.button&&this.button.addEventListener("click",this.toggle.bind(this))}toggle(o,t){t||(o.preventDefault(),o.stopPropagation());const e=this.button.getAttribute("aria-expanded")==="false";this.button.setAttribute("aria-expanded",e);const s=this.button.nextElementSibling;if(!this.button.closest(".link-dropdown").classList.contains("link-dropdown--left-aligned"))if(e){this.button.style.width=`${this.button.clientWidth}px`;const r=s.clientWidth+(document.querySelector("html[dir=rtl]")?parseInt(getComputedStyle(s).left,10):parseInt(getComputedStyle(s).right,10))-parseInt(getComputedStyle(s.querySelector(".link-dropdown__link")).paddingInlineStart,10);setTimeout(()=>{this.button.style.width=`${r}px`},10)}else this.button.style.width="";e?(this.open=!0,this.addDismissListener()):(this.open=!1,this.removeDismissListener())}addDismissListener(){this.dismissCallback&&document.removeEventListener("click",this.dismissCallback),this.dismissCallback=this.toggle.bind(this,!0);try{document.addEventListener("click",this.dismissCallback)}catch{this.dismissCallback=null}}removeDismissListener(){if(this.dismissCallback){try{document.removeEventListener("click",this.dismissCallback)}catch(o){console.error("Failed to remove dismiss listener:",o)}this.dismissCallback=null}}destroy(){this.removeDismissListener(),this.button&&this.button.removeEventListener("click",this.toggle.bind(this))}}function pe(){document.querySelectorAll("[data-tagalys-ui-widget] link-dropdown:not([data-tagalys-initialized])").forEach(o=>{o.setAttribute("data-tagalys-initialized","true"),new ue(o)})}function ee(n,o,t){const e=o.querySelector(".swiper-wrapper");if(!e)return;const s=t?'.swiper-slide[data-is-model-view="true"]':'.swiper-slide[data-is-product-view="true"]',i=o.querySelector(s);if(!i)return;const r=!!n.params.loop;if(r&&typeof n.loopDestroy=="function"&&n.loopDestroy(),e.firstElementChild!==i&&e.insertBefore(i,e.firstElementChild),t){const a=o.querySelector('.swiper-slide[data-is-product-view="true"]');a&&e.lastElementChild!==a&&e.appendChild(a)}r&&typeof n.loopCreate=="function"&&n.loopCreate(),n.update(),n.slideTo(0,0)}function ge(){const n=document.querySelector("[data-tagalys-ui-widget] #model_view_toggle");if(!n)return;typeof window.theme>"u"&&(window.theme={}),typeof window.theme.settings>"u"&&(window.theme.settings={}),window.theme.settings.model_view_active=n.checked;const o=n.tagalysModelViewHandler;o&&n.removeEventListener("change",o);const t=function(e){window.theme.settings.model_view_active=e.target.checked,document.dispatchEvent(new CustomEvent("theme:model_view",{bubbles:!0,cancelable:!1,detail:{active:e.target.checked}}))};n.tagalysModelViewHandler=t,n.addEventListener("change",t)}function he(){H.forEach(n=>{try{n.destroy(!0,!0)}catch(o){console.warn("Error destroying swiper:",o)}}),H=[]}function fe(n){const o=n.closest(".product-block");return o&&o.hasAttribute("data-in-carousel")?o.getAttribute("data-in-carousel")==="true":!1}function C(){const n=document.querySelectorAll("[data-tagalys-ui-widget] carousel-slider, [data-product-based-widget] carousel-slider");document.dispatchEvent(new CustomEvent("tagalys:carousels-rendered",{bubbles:!0,detail:{carousels:Array.from(n)}}))}function x(){he();const n=document.querySelectorAll(".js-product-block-swiper"),o=!window.matchMedia("(hover: hover)").matches;n.forEach((t,e)=>{t.getAttribute("data-product-id");const s=parseInt(t.getAttribute("data-total-images"))||1,i=fe(t);try{const r=t.querySelector(".swiper-wrapper"),a=r?r.querySelectorAll(".swiper-slide"):[];if(!r||a.length===0)return;const l={modules:[ie,re,oe,ne,ae],slidesPerView:1,spaceBetween:0,loop:!0,speed:300,navigation:{nextEl:t.querySelector(".swiper-button-next"),prevEl:t.querySelector(".swiper-button-prev")},pagination:{el:t.querySelector(".swiper-pagination"),type:"progressbar"},keyboard:{enabled:!0,onlyInViewport:!0},a11y:{prevSlideMessage:"Previous image",nextSlideMessage:"Next image",slideLabelMessage:"Image {{index}} of {{slidesLength}}"},on:{slideChange:function(p){},slideChangeTransitionStart:function(p){}}};i?(l.mousewheel={enabled:!1},l.allowTouchMove=!1,l.touchRatio=0):(l.mousewheel={enabled:!0,sensitivity:1,thresholdDelta:50,forceToAxis:!0},l.touchRatio=o?1:.2,l.threshold=10);const c=new le(t,l);if(s>1){let p=1;t.addEventListener("mouseenter",()=>{!c.destroyed&&!o&&c.slideTo(p,0)}),t.addEventListener("mouseleave",()=>{!c.destroyed&&!o&&c.slideTo(0,0)})}const u=!!(window.theme&&window.theme.settings&&window.theme.settings.model_view_active);ee(c,t,u);const d=p=>{ee(c,t,p.detail.active)};document.addEventListener("theme:model_view",d),c.cleanupHandler=()=>{document.removeEventListener("theme:model_view",d)},H.push(c)}catch(r){console.error(r)}})}function me(n){const o=document.querySelector(".search-content, .main-search, [data-search-container]");if(!o){const t=document.querySelector($.searchSuggestions);if(t){const e=t.closest(".search-content, .main-search, .container, main");e&&te(e,n)}return}te(o,n)}function te(n,o){const t=!o.exceedsMinimumCharactersToShowSuggestions();n.classList.remove(N.tagalysNoResults,N.tagalysHasResults),t?n.classList.add(N.tagalysNoResults):n.classList.add(N.tagalysHasResults)}function ve(){if(!window.Tagalys||!window.Tagalys.UIWidgets||!window.Tagalys.UIWidgets.Recommendations)return;document.querySelectorAll("[data-click-suggestions-widget]:not([data-tagalys-initialized])").forEach(o=>{const t=o.getAttribute("data-recommendation-id"),e=o.getAttribute("data-display-format")||"grid",s=parseInt(o.getAttribute("data-product-limit"))||8,i=o.getAttribute("data-section-title")||"Recommended for you",r=o.getAttribute("data-section-button-url")||null,a=o.getAttribute("data-section-button-text")||null;if(!t)return;o.setAttribute("data-tagalys-initialized","true");const l=e==="carousel";try{Tagalys.UIWidgets.Recommendations.init(`[data-recommendation-id="${t}"]`,TagalysCustomisations.productBasedWidgetUtilities.getRecommendationConfig(t,{inCarousel:l,widget:{labels:{heading:i,buttonText:a,buttonUrl:r},options:{count:s,displayFormat:e}}}))}catch(c){console.error("Error initializing click suggestions recommendation widget:",c)}})}TagalysCustomisations.initProductBasedWidget=function(){if(!window.Tagalys||!window.Tagalys.UIWidgets||!window.Tagalys.UIWidgets.Recommendations)return;const n=document.querySelectorAll("[data-product-based-widget]");n.length&&n.forEach(o=>{const t=o.getAttribute("data-recommendation-id"),e=JSON.parse(o.getAttribute("data-product-ids"))||[];if(!t)return;const s=o.hasAttribute("data-in-carousel")||o.getAttribute("data-in-carousel")==="true",i=o.getAttribute("data-section-id"),r=o.getAttribute("data-section-title"),a=o.getAttribute("data-section-button-url")||null,l=o.getAttribute("data-section-button-text")||null,c=o.getAttribute("data-display-format"),u=o.getAttribute("data-product-limit");if(!i)return;const d={productIds:e,inCarousel:s};(r||c||u)&&(d.widget={},r&&(d.widget.labels={heading:r}),a&&l&&(a&&(d.widget.labels.buttonLink=a),l&&(d.widget.labels.buttonText=l)),(c||u)&&(d.widget.options={},c&&(d.widget.options.displayFormat=c),u&&(d.widget.options.count=parseInt(u,10))));try{Tagalys.UIWidgets.Recommendations.init(`[data-section-id="${i}"]`,TagalysCustomisations.productBasedWidgetUtilities.getRecommendationConfig(t,d))}catch(p){console.error("Error initializing product-based widget:",p,o)}})};TagalysCustomisations.initSearchSuggestions=function(){if(!window.Tagalys||!window.Tagalys.UIWidgets||!window.Tagalys.UIWidgets.SearchSuggestions)return;const n=document.querySelector($.searchSuggestions),o=document.querySelector($.searchSuggestionsInput);!n||!o||n&&o&&Tagalys.UIWidgets.SearchSuggestions.init($.searchSuggestionsInput,{searchResultsURL:window.theme.routes.search,callbacks:{onSuccessfulAPICall:async function(t,e){const s=t.sections.products.items||[];if(!s||!Array.isArray(s))return t;const i=await se(s);return t.sections.products.items=s.map(r=>{const a=i[r.id];return a&&a.length>0&&(r.metafields||(r.metafields={}),r.metafields.colour||(r.metafields.colour={}),r.metafields.colour.variations||(r.metafields.colour.variations={}),r.metafields.colour.variations.items=a),r}),t}},templates:{widget:{options:{sections:{collections:{count:5},pages:{count:5},products:{include:["total_count","items"],count:8}},request:{products:{count:8}},includeTagalysCSS:!1,position:!1,selector:$.searchSuggestions,inheritAlignmentElementWidth:!1},render:function(t,e){var s=e.props,i=s.helpers,r=i.getTargetNodeWidth(),a=s.inheritAlignmentElementWidth?{width:r}:{};return t`
              <div ref=${s.tagalysSearchSuggestionsPopoverRef} style=${a} class="search-suggestions">
                ${i.exceedsMinimumCharactersToShowSuggestions()?t` <${e.templates.typeSuggestions} /> `:t` <${e.templates.clickSuggestions} /> `}
              </div>
            `},callbacks:{afterEveryRender:function(t){me(t),setTimeout(()=>{ve()},50)}}},hint:{render:function(t,e){var s=e.props,i=s.helpers,r=i.getTemplateOptions("widget"),a=()=>{var l=e.labels;return i.exceedsMinimumCharactersToShowSuggestions()?l.hint.atOrOverMinimumCharacters.replace("{{searchTerm}}",i.getEnteredSearchQuery()):l.hint.underMinimumCharacters.replace("{{minimumCharactersToShowSuggestions}}",r.minimumCharactersToShowSuggestions)};return t`
              <div class="hint search-suggestions__hint">
                <a
                  class="search-results-link"
                  href=${i.getURLEncodedQueryString({query:i.getEnteredSearchQuery()})}
                >
                  ${a()}
                </a>
                <button
                  type="button"
                  class="search-suggestions__close-button"
                  onClick=${i.hideSearchSuggestionsPopover}
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    class="icon close-icon"
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                  >
                    <path
                      d="M14.8955 2L2.8584 14.0371"
                      stroke="currentColor"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.8584 2L14.8955 14.0371"
                      stroke="currentColor"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            `}},clickSuggestions:{render:function(t,e){var u,d,p,h,g,v,A,F,k,T,R,O;var s=e.props.helpers,i=s.getRecentAndPopularSearches();const r=(d=(u=window.theme)==null?void 0:u.tagalysSettings)==null?void 0:d.clickSuggestionsRecommendationId,a=((h=(p=window.theme)==null?void 0:p.tagalysSettings)==null?void 0:h.clickSuggestionsDisplayFormat)||"grid",l=a==="carousel",c=t`
              <ul class="click-suggestions">
                ${i.recentSearches.map(I=>t` <${e.templates.recentSearchItem} recentSearch=${I} /> `)}
                ${i.popularSearches.map(I=>t` <${e.templates.popularSearchItem} popularSearch=${I} /> `)}
              </ul>
            `;return r?(TagalysCustomisations.productBasedWidgetUtilities.getRecommendationConfig(r,{inCarousel:l,widget:{labels:{heading:((v=(g=window.theme)==null?void 0:g.tagalysSettings)==null?void 0:v.clickSuggestionsSectionTitle)||"Recommended for you"},options:{count:((F=(A=window.theme)==null?void 0:A.tagalysSettings)==null?void 0:F.clickSuggestionsProductLimit)||8,displayFormat:a}}}),t`
                ${c}
                <div
                  class="click-suggestions-recommendations tagalys-recommendations"
                  data-click-suggestions-widget
                  data-recommendation-id="${r}"
                  data-display-format="${a}"
                  data-product-limit="${((T=(k=window.theme)==null?void 0:k.tagalysSettings)==null?void 0:T.clickSuggestionsProductLimit)||8}"
                  data-section-title="${((O=(R=window.theme)==null?void 0:R.tagalysSettings)==null?void 0:O.clickSuggestionsSectionTitle)||"Recommended for you"}"
                >
                  <!-- Recommendations will be initialized here via JavaScript -->
                </div>
              `):c}},recentSearchItem:{render:function(t,e){var s=e.props,i=s.helpers,r=i.getEnteredSearchQuery();return t`
              <li class="click-suggestion recent-search-item">
                <a class="search-results-link" href=${i.getLink(s.recentSearch.query)}>
                  <${e.templates.recentSearchIcon} />
                  <${e.templates.highlighter} label=${s.recentSearch.query} highlight=${r} />
                </a>
                <button
                  type="button"
                  class="recent-search-item__close-button"
                  onClick=${()=>i.removeRecentSearch(s.recentSearch.query)}
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    class="icon close-icon"
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                  >
                    <path
                      d="M14.8955 2L2.8584 14.0371"
                      stroke="currentColor"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.8584 2L14.8955 14.0371"
                      stroke="currentColor"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </li>
            `}},popularSearchItem:{render:function(t,e){var s=e.props,i=s.helpers,r=i.getEnteredSearchQuery();return t`
              <li class="click-suggestion popular-search-item">
                <a class="search-results-link" href=${i.getLink(s.popularSearch.query)}>
                  <${e.templates.popularSearchIcon} />
                  <${e.templates.highlighter} label=${s.popularSearch.query} highlight=${r} />
                </a>
              </li>
            `}},typeSuggestions:{render:function(t,e){var s=e.props,i=s.helpers,r=i.getTextSuggestions();const a=()=>{var u,d,p,h;return((d=(u=window.theme)==null?void 0:u.tagalysSettings)==null?void 0:d.enableTextSuggestions)===!1?!1:((h=(p=window.theme)==null?void 0:p.tagalysSettings)==null?void 0:h.enableTextSuggestions)===!0?r&&r.length>0:i.hasTextSearchSuggestions()>0};var l=["type-suggestions"];a()?l.push("product-and-text-suggestions"):l.push("product-suggestions");var c=l.join(" ");return t`
              <div class=${c}>
                <${e.templates.products} class="product-suggestions" />
                ${a()?t`
                      <ul class="text-suggestions">
                        ${r.map(u=>t`
                              <${e.templates.textSuggestionSection} textSuggestionSection=${u} />
                            `)}
                      </ul>
                    `:null}
              </div>
            `}},textSuggestionSection:{render:function(t,e){var s=e.props,i=s.textSuggestionSection;return i.items.length>0?t`
                <li class="text-suggestion-section" data-section-id=${i.id}>
                  <span class="section-title heading-3 semi-bold"> ${i.title} </span>
                  <ul>
                    ${i.items.map(function(r){return t`
                        <${e.templates.textSuggestionSectionItem}
                          textSuggestionSectionId=${i.id}
                          textSuggestionSectionItem=${r}
                        />
                      `})}
                  </ul>
                </li>
              `:null}},textSuggestionSectionItem:{render:function(t,e){var s=e.props,i=s.helpers,r=i.getEnteredSearchQuery(),a=s.textSuggestionSectionItem,l=a.hasOwnProperty("link")?a.link:s.helpers.getLink(a.query),c=a.hasOwnProperty("title")?a.title:a.query;return t`
              <li>
                <a class="search-results-link" href=${l}>
                  <${e.templates.highlighter} label=${c} highlight=${r} />
                </a>
              </li>
            `}},products:{render:function(t,e){const i=e.props.helpers.getProducts();return t`
              <div class="product-grid product-grid--per-row-4 product-grid--per-row-mob-2">
                ${i.map((r,a)=>t` <${e.templates.product} key=${r.id} product=${r} /> `)}
              </div>
            `},callbacks:{afterInitialRender:function(t){setTimeout(()=>{x(),C()},50)},afterEveryRender:function(t){setTimeout(()=>{x(),C()},50)}}},product:{render:U}}})};TagalysCustomisations.initSearchResults=function(n){if(!window.Tagalys||!window.Tagalys.UIWidgets||!window.Tagalys.UIWidgets.SearchResults)return;const o=document.querySelector($.searchResults);o&&o&&Tagalys.UIWidgets.SearchResults.init($.searchResults,{callbacks:{onSuccessfulAPICall:async function(t,e){return t.hasOwnProperty("total")&&(document.title=`Search: ${t.total} result${t.total>1?"s":""} found for "${t.query}" – ${window.theme.strings.shop.name}`),await TagalysCustomisations.productBasedWidgetUtilities.onSuccessfulAPICall(t,e)}},templates:{widget:{options:{minimumCharactersToShowSuggestions:2,includeTagalysCSS:!1,limit:o.dataset.productsPerPage??56,labels:{pagination:{loadMore:"{{ 'general.pagination.load_more' | t | default: 'Load more' }}"}}},render:function(t,e){var s=e.props,i=s.helpers;if(i.isInitialLoading())return t` <${e.templates.loader} /> `;let r=["container container--no-max container--collection","search-results"];i.isLoading()&&r.push("loading"),i.canShowFiltersInDrawer()&&r.push("show-filters-in-drawer");var a=r.join(" ");return i.hasNoSearchResults()&&!i.hasAnyFiltersApplied()?t`
                <div class="plp search-results">
                  <${e.templates.noResults} />
                </div>
              `:t`
              <div class=${a}>
                <${e.templates.header} />

                <filter-container
                  class="filter-container filter-container--side ${i.isFilterDrawerOpen()?"filter-container--mobile-initialised filter-container--show-filters-desktop filter-container--show-filters-mobile":""}"
                >
                  ${i.isFilterDrawerOpen()?t` <div class="filter-shade" onclick=${i.closeFilterDrawer} />`:null}

                  <${e.templates.filters} />
                  <div class="products-list">
                    <${e.templates.products} />
                  </div>
                </filter-container>
                <${e.templates.productListFooter} />
              </div>
              <${e.templates.footer} />
            `}},loader:{render:function(t,e){return t`<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>`}},heading:{render:function(t,e){const s=e.props,i=e.labels,r=s.helpers;return t` <h2 class="pagetitle heading-2 semi-bold">${r.isPartialResults()?i.searchResults.heading.partialMatches.replace("{{searchTerm}}",r.getQuery()):r.isSpellingCorrectedQuery()?i.searchResults.heading.corrected.replace("{{originalSearchTerm}}",r.getOriginalQuery()).replace("{{resultsCount}}",r.getTotalProductsCount()).replace("{{correctedSearchTerm}}",r.getQuery()):i.searchResults.heading.standard.replace("{{resultsCount}}",r.getTotalProductsCount()).replace("{{searchTerm}}",r.getQuery())}</h2> `}},header:{render:function(t,e){var l;const i=e.props.helpers,r=i.isFilterDrawerOpen(),a=((l=i.getAppliedFilters())==null?void 0:l.length)||0;return t`
              <div class="page-header--with-upper-spacing mobile-only">
                <${e.templates.heading} />
              </div>
              <div class="utility-bar" data-ajax-container data-ajax-scroll-to>
                <div class="utility-bar__left">
                  <button
                    type="button"
                    class="toggle-btn utility-bar__item ${r&&"toggle-btn--revealed-desktop"}"
                    data-toggle-filters
                    onClick=${i.toggleFilterDrawer}
                  >
                    ${r?t`<span class="toggle-btn__label--hide">Hide</span
                          ><span class="toggle-btn__label">Filters</span>
                          <span class="toggle-btn__label--sort mobile-only">& Sort</span>
                          ${a>0?t`<span class="toggle-btn__count">(${a})</span>`:""}
                          <span class="toggle-btn__icon toggle-btn__open ltr-icon">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="icon feather feather-minus"
                              aria-hidden="true"
                              focusable="false"
                              role="presentation"
                            >
                              <path d="M5 12h14" />
                            </svg>
                          </span>`:t`<span class="toggle-btn__label--show">Add</span
                          ><span class="toggle-btn__label">Filters</span>
                          <span class="toggle-btn__label--sort mobile-only">& Sort</span>
                          ${a>0?t`<span class="toggle-btn__count">(${a})</span>`:""}<span class="toggle-btn__icon toggle-btn__closed ltr-icon">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              class="icon"
                              aria-hidden="true"
                              focusable="false"
                              role="presentation"
                            >
                              <path
                                d="M7.92664 1.01831V14.5083M1.18164 7.76331H14.6716"
                                stroke="currentColor"
                                stroke-linecap="square"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>`}
                  </button>
                </div>

                <div class="utility-bar__centre desktop-only">
                  <${e.templates.heading} />
                </div>

                <div class="utility-bar__right">
                  <span class="utility-bar__item flex nowrap align-center paragraph small">
                    Model View
                    <input class="switch" type="checkbox" id="model_view_toggle" checked />
                    <label for="model_view_toggle"></label>
                  </span>

                  <${e.templates.sortOptions} />
                </div>
              </div>
            `}},sortOptions:{render:function(t,e){const s=e.props,i=e.labels,r=s.helpers,a=r.getSortOptions(),l=r.getAppliedSortOption(),c=u=>{r.applySortOption(u.target.value)};return t`
              <span class="utility-bar__item desktop-only">
                <link-dropdown class="link-dropdown link-dropdown--right-aligned">
                  <div class="visually-hidden" id="sort-dropdown-heading">${i.sortOptions.sortBy}</div>
                  <button
                    class="link-dropdown__button has-motion"
                    aria-expanded="false"
                    aria-controls="sort-dropdown-options"
                    aria-describedby="sort-dropdown-heading"
                  >
                    <span class="link-dropdown__button-text"> ${l.label} </span>
                    <span class="link-dropdown__button-icon has-motion">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="icon feather feather-chevron-down"
                        aria-hidden="true"
                        focusable="false"
                        role="presentation"
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </span>
                  </button>
                  <div class="link-dropdown__options" id="sort-dropdown-options">
                    ${a.map(u=>t`
                        <button
                          type="button"
                          value=${u.id}
                          onClick=${c}
                          class="link-dropdown__link ${u.id==l.id?"link-dropdown__link--active":""}"
                        >
                          ${u.label}
                        </button>
                      `)}
                  </div>
                </link-dropdown>
              </span>
            `},callbacks:{afterEveryRender:function(t){setTimeout(()=>{pe(),ge()},50)}}},products:{render:function(t,e){var l;const i=e.props.helpers,r=i.getProducts(),a=i.getCurrentPage&&i.getCurrentPage()>1;return t`
              <div class="product-grid product-grid--per-row-4 product-grid--per-row-mob-2" 
                  data-product-grid
                  data-current-page="${((l=i==null?void 0:i.getCurrentPage)==null?void 0:l.call(i))??1}"
                  data-append-mode="${a}">
                ${r.map(c=>t`<${e.templates.product} key=${c.id} product=${c} />`)}
              </div>
            `},callbacks:{afterInitialRender:function(t){setTimeout(()=>{x(),C()},50)},afterEveryRender:function(t){const e=document.querySelectorAll("[data-product-grid]");if(e.length>1){const s=e[0],i=e[e.length-1];i!==s&&i.dataset.appendMode==="true"&&(s.append(...i.children),i.remove())}setTimeout(()=>{x(),C()},50)}}},product:{render:U},filtersHeader:{render:function(t,e){const s=e.props,i=e.labels,r=s.helpers;return t`
              <header class="filters__heading">
                <h2 class="filters__heading-text heading-font h4">${i.filters.heading}</h2>
                <button
                  type="button"
                  class="filters__close"
                  aria-label="${i.filters.drawerFilterToggle}"
                  onClick=${r.closeFilterDrawer}
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    class="icon"
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                  >
                    <path
                      d="M14.8955 2L2.8584 14.0371"
                      stroke="currentColor"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.8584 2L14.8955 14.0371"
                      stroke="currentColor"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </header>
            `}},filters:{options:{collapsible:!0,includeSortOptionsInFilters:"top",autoCollapse:!1,showAppliedFilters:!0,showClearAllFilters:!0,showClearActionForIndividualFilters:!0,showMatchingProductsCount:!0,defaultExpandedFilters:[],showFiltersInDrawer:()=>window.innerWidth<=768,expandTopNFiltersByDefault:!1},render:function(t,e){var s=e.props,i=s.helpers,r=i.getFilters(),a=["filters"];s.collapsible&&a.push("collapsible");var l=a.join(" ");return t`
              <div class=${l}>
                <div class="filters__inner">
                  <${e.templates.filtersHeader} />
                  ${s.showAppliedFilters?t` <${e.templates.appliedFilters} /> `:null}
                  ${s.includeSortOptionsInFilters==="top"?t` <${e.templates.sortOptionInFilters} /> `:null}
                  ${r.map(c=>t`<${e.templates.filter} filter=${c} />`)}
                  ${s.includeSortOptionsInFilters===!0||s.includeSortOptionsInFilters==="bottom"?t` <${e.templates.sortOptionInFilters} /> `:null}
                </div>
              </div>
            `}},appliedFilters:{render:function(t,e){var s=e.props,i=s.helpers,r=e.labels,a=i.getAppliedFilters(!0);return a.length?t`
              <div class="filter-group filter-group--applied">
                <div class="filter-group__items">
                  ${a.map(l=>l.type==="range"?t`
                        <button
                          type="button"
                          onClick=${()=>i.clearFilter(l.id)}
                          class="filter-group__applied-item"
                        >
                          <span class="filter-group__applied-item__text">
                            ${i.labelFormatter(l.display_format,l.selected_min,l.currency)}
                            -
                            ${i.labelFormatter(l.display_format,l.selected_max,l.currency)}
                          </span>
                          <span class="filter-group__applied-item__icon">
                            <svg
                              width="17"
                              height="17"
                              viewBox="0 0 17 17"
                              fill="none"
                              class="icon"
                              aria-hidden="true"
                              focusable="false"
                              role="presentation"
                            >
                              <path
                                d="M14.8955 2L2.8584 14.0371"
                                stroke="currentColor"
                                stroke-linecap="square"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M2.8584 2L14.8955 14.0371"
                                stroke="currentColor"
                                stroke-linecap="square"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </button>
                      `:l.items.map(c=>t`
                        <button
                          type="button"
                          class="filter-group__applied-item"
                          onClick=${()=>i.clearFilter(l.id,c.id)}
                        >
                          <span class="filter-group__applied-item__text"> ${c.label} </span>
                          <span class="filter-group__applied-item__icon">
                            <svg
                              width="17"
                              height="17"
                              viewBox="0 0 17 17"
                              fill="none"
                              class="icon"
                              aria-hidden="true"
                              focusable="false"
                              role="presentation"
                            >
                              <path
                                d="M14.8955 2L2.8584 14.0371"
                                stroke="currentColor"
                                stroke-linecap="square"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M2.8584 2L14.8955 14.0371"
                                stroke="currentColor"
                                stroke-linecap="square"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </button>
                      `))}
                  <button type="button" class="filter-group__clear-link" onclick=${i.clearAllFilters}>
                    ${r.filters.clearAllFilters}
                  </button>
                </div>
              </div>
            `:null}},sortOptionInFilters:{render:function(t,e){var s=e.props,i=s.helpers,r=e.labels,a=i.getTemplateOptions("filters"),l=i.getAppliedSortOption(),c=i.getSortOptions();let u=["filter-group mobile-only"],d=!1;a.collapsible&&(d=i.isCollapsibleFilterExpanded("sort_options"),d?u.push("expanded"):u.push("toggle-target-toggler--is-hidden"));var p=u.join(" ");return t`
              <div data-filter-id="sort_options" class=${p}>
                <${e.templates.filterHeader} filterHeading=${r.sortOptions.sortBy} filterId=${"sort_options"} />
                <div
                  class="filter-group__items filter-group--sort toggle-target ${d?"expanded":"toggle-target--hidden"}"
                >
                  ${c.map(h=>{const g=h.id===l.id;return t`
                      <label
                        class="filter-group__item ${g?"filter-group__item--active":""}"
                        data-filter-item-id=${h.id}
                        onClick=${()=>i.applySortOption(h.id)}
                      >
                        <input class="filter-group__radio" checked=${g} type="radio" />
                        <span class="filter-group__item__text">${h.label}</span>
                      </label>
                    `})}
                </div>
              </div>
            `}},filter:{render:function(t,e){var s=e.props;s.helpers;var i=["filter-group"];s.filter.id.includes("size")&&i.push("filter-group--button-grid filter-group--layout-three-column");var r=i.join(" ");return t`
              <div class=${r} data-filter-id=${s.filter.id}>
                <${e.templates.filterHeader} filterHeading=${s.filter.label} filterId=${s.filter.id} />
                <${e.templates.filterItems} filter=${s.filter} />
              </div>
            `}},filterHeader:{render:function(t,e){var s=e.props,i=s.helpers,r=["filter-group__heading"],a=i.getTemplateOptions("filters"),l=()=>{i.toggleCollapsibleFilter(s.filterId)},c=!1;s.collapsible&&(c=i.isCollapsibleFilterExpanded(s.filterId),c?r.push("expanded"):r.push("toggle-target-toggler--is-hidden"));var u=r.join(" ");return t`
              <toggle-target
                onClick=${a.collapsible?l:void 0}
                class=${u}
              >
                <div class="filter-group__heading__text">${s.filterHeading}</div>
                <span class="filter-group__heading__indicator">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon feather feather-chevron-down"
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                  >
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </span>
              </toggle-target>
            `}},filterItems:{render:function(t,e){var s=e.props,i=s.helpers,r=e.labels,a=["filter-group__items toggle-target"],l=i.getTemplateOptions("filters"),c=l.showClearActionForIndividualFilters&&i.isFilterApplied(s.filter.id),u=h=>{h.stopPropagation(),i.clearFilter(s.filter.id)},d=!1;d=i.isCollapsibleFilterExpanded(s.filter.id),d?a.push("expanded"):a.push("toggle-target--hidden");var p=a.join(" ");return s.filter.type==="checkbox"?t`
                <div class=${p}>
                  <div class="toggle-target-container">
                    <${e.templates.filterCheckBoxes} filterId=${s.filter.id} filterItems=${s.filter.items} />
                  </div>
                  <span class="filter-actions">
                    ${c?t`
                          <button type="button" onClick=${u} class="filter-group__clear-link">
                            ${r.filters.clearIndividualFilter}
                          </button>
                        `:null}
                  </span>
                </div>
              `:t`
              <div class=${p}>
                <div class="toggle-target-container">
                  <${e.templates.rangeSliderFilterItem} filter=${s.filter} />
                </div>
              </div>
            `}},filterCheckBoxes:{render:function(t,e){var s=e.props;return t`
              ${s.filterItems.map(i=>t`
                <${e.templates.checkboxFilterItem}
                  filterId=${s.filterId}
                  filterItem=${i}
                >
                ${i.selected&&i.items?t`
                        <${e.templates.filterCheckBoxes}
                          filterId=${s.filterId}
                          filterItems=${i.items}
                        />
                      `:null}
              </${e.templates.checkboxFilterItem}>
            `)}
            `}},checkboxFilterItem:{render:function(t,e){var s=e.props,i=s.helpers,r=s.showMatchingProductsCount;s.filterId.includes("size")&&(r=!1);const a=l=>{l.stopPropagation(),s.filterItem.selected?i.clearFilter(s.filterId,s.filterItem.id):i.applyFilter(s.filterId,s.filterItem.id)};return t`
              <label
                class="filter-group__item ${s.filterItem.selected?"filter-group__item--active":""}"
                data-filter-item-id=${s.filterItem.id}
                onClick=${a}
              >
                <input class="filter-group__checkbox" checked=${s.filterItem.selected} type="checkbox" />
                <span class="filter-group__item__text"
                  >${s.filterItem.label}
                  <svg class="filter-tick" role="presentation" viewBox="0 0 20 20">
                    <path
                      d="M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.436.436 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0"
                    ></path>
                  </svg>
                </span>
                ${r?t` <span class="filter-group__item__count">${s.filterItem.count}</span> `:null}
                ${s.children}
              </label>
            `}},pagination:{options:{infiniteScroll:!0,showLoadNextAfterEvery:1},render:function(t,e){var s=e.props,i=s.helpers;return s.infiniteScroll?i.canLoadNextResults(s.showLoadNextAfterEvery)?t`<${e.templates.loadNext} />`:null:t`<${e.templates.paginationLinks} />`}},loadNext:{render:function(t,e){var l;var s=e.props.helpers;const i=((l=s.isLoading)==null?void 0:l.call(s))??!1;return t`
              <div class="container pagination-row">
                <div class="pagination" data-pagination>
                  <button
                    type="button"
                    class="btn pagination__load-more ${i?"loading":""}"
                    data-load-more
                    onClick=${c=>{c.preventDefault(),s.loadNextPage?s.loadNextPage():console.error("loadNextPage not available")}}
                    disabled=${i}
                  >
                    ${i?t`<span class="loading-spinner"></span>`:"Load More"}
                  </button>
                </div>
              </div>
            `}},paginationLinks:{options:{showNumberedPageLinks:!0,numberedPageLinksWindowSize:3,showPreviousPageLink:!0,showFirstPageLink:!0,showNextPageLink:!0,scrollTop:!0},render:function(t,e){var s=e.props,i=s.helpers,r=e.labels,a=i.getPagesToDisplay(s.numberedPageLinksWindowSize),l=i.getCurrentPage(),c=i.hasPreviousPage(),u=i.hasNextPage();return t` ${a.length>1&&t`
              <div class="container pagination-row">
                <div class="pagination">
                  ${s.showPreviousPageLink&&c?t`
                        <button
                          type="button"
                          class="pagination__prev pagination__link text-current underline underline--on-hover ${`${c?"":" disabled"}`}"
                          onclick=${l===1?void 0:i.goToPreviousPage}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="{{ stroke_width | default: 1.5 }}"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="icon feather feather-chevron-left"
                            aria-hidden="true"
                            focusable="false"
                            role="presentation"
                          >
                            <path d="m15 18-6-6 6-6" />
                          </svg>
                          ${r.pagination.previousPage}
                        </button>
                      `:null}
                  ${s.showNumberedPageLinks?a.map(d=>{var p=["pagination__link text-current"],h=d.jumpAfter;d.current&&p.push("underline"),d.current||p.push("underline--on-hover"),d.jumpAfter&&p.push("page-jump-over");var g=p.join(" ");return t`
                          <button
                            class=${`${g}`}
                            onclick=${()=>{!h&&i.goToPage(d.page)}}
                          >
                            ${h?"...":d.page}
                          </button>
                        `}):null}
                  ${s.showNextPageLink&&u?t`
                        <button
                          class=${`pagination__next pagination__link text-current underline underline--on-hover${u?"":" disabled"}`}
                          onclick=${u?i.goToNextPage:void 0}
                        >
                          ${r.pagination.nextPage}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="{{ stroke_width | default: 1.5 }}"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="icon feather feather-chevron-right"
                            aria-hidden="true"
                            focusable="false"
                            role="presentation"
                          >
                            <path d="m9 18 6-6-6-6" />
                          </svg>
                        </button>
                      `:null}
                </div>
              </div>
            `}`}},footer:{render:function(t){return t``}},noResults:{render:function(t,e){var c,u,d,p,h,g;var s=e.labels;const i=(u=(c=window.theme)==null?void 0:c.tagalysSettings)==null?void 0:u.noResultsRecommendationId;if(!i)return t`
                <div class="no-results">
                  <!-- No recommendation widget rendered due to missing configuration -->
                </div>
              `;window._tagalysParentLabels=s;const r=((p=(d=window.theme)==null?void 0:d.tagalysSettings)==null?void 0:p.noResultsDisplayFormat)||"grid",a=r==="carousel",l={widgets:[{recommendationId:i,options:TagalysCustomisations.productBasedWidgetUtilities.getRecommendationConfig(i,{inCarousel:a,widget:{options:{count:((g=(h=window.theme)==null?void 0:h.tagalysSettings)==null?void 0:g.noResultsProductLimit)||8,displayFormat:r}}})}]};return t`
              <div class="no-results">
                <${e.templates.noResultsWidgets} ...${l} />
              </div>
            `}}}})};const U=(n,o)=>{var W,D,z;const t=o.props,e=t.product,s=t.helpers,i=t.inCarousel||!1,a=s.getTemplateOptions("product").productPageUrl(e),l=window.theme.settings||{},c=l.prodThumbHoverImage&&e.images&&e.images.length>1,u=l.prodThumbTextAlign||"left",d=l.prodThumbShowVendor||!1,p=l.prodThumbShowSubtitle||!1,h=l.prodThumbShowProductQtySelector||!1;let g=e.images||[];g.length>1&&(g=g.slice(0,-1)),g[0],g.length>1&&g[1];const v=g.length,A=()=>g.map((f,m)=>{const w=m===0,y=m===1,q=m===g.length-1;let S="swiper-slide product-block__image";w&&(S+=" product-block__image--primary product-block__image--model-view"),q&&(S+=" product-block__image--product-view"),y&&c&&(S+=" product-block__image--hover");const B="20",j=["375","770","1080"],P=Y(f.src,`${B}x_crop_center`),E=j.map(L=>`${Y(f.src,`${L}x_crop_center`)} ${L}w`).join(", ");return n`
        <div
          class="${S}"
          data-media-id="${f.id||m}"
          data-image-index="${m}"
          data-is-primary="${w}"
          data-is-model-view="${w}"
          data-is-product-view="${q}"
          data-is-hover="${y&&c}"
        >
          <img
            class="lazyload"
            src="${P}"
            data-src="${P}"
            data-srcset="${E}"
            data-sizes="auto"
            width="${f.width||600}"
            height="${f.height||600}"
            alt="${f.alt||`${e.title} - Image ${m+1}`}"
            loading="lazy"
          />
        </div>
      `}),F=()=>v<=1?null:n`
      <div class="swiper-button-prev" tabindex="-1">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="15,18 9,12 15,6"></polyline>
        </svg>
      </div>
      <div class="swiper-button-next" tabindex="-1">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="9,6 15,12 9,18"></polyline>
        </svg>
      </div>
      <div class="swiper-pagination"></div>
    `,k=f=>s.formatCurrency(f),T=()=>s.isProductOnSale(e.compare_at_price,e.price),R=()=>{if(!e.variants||e.variants.length===0)return null;const f=e.variants.slice(0,7);return n`
      <div class="product-quantity-selector">
        ${f.map(m=>{const w=`${a}?variant=${m.id}`,y=!m.available;return n`
            <a href="${w}" class="product-quantity-selector_button ${y?"unavailable":""}">
              ${m.title}
            </a>
          `})}
      </div>
    `},O=()=>{var B,j,P,E,L,Q,V,G,J;const f=(P=(j=(B=e.metafields)==null?void 0:B.colour)==null?void 0:j.swatch)==null?void 0:P.value,m=(Q=(L=(E=e.metafields)==null?void 0:E.colour)==null?void 0:L.colour)==null?void 0:Q.value,w=((J=(G=(V=e.metafields)==null?void 0:V.colour)==null?void 0:G.variations)==null?void 0:J.items)||[];if(!f&&w.length===0)return null;const y=(b,M)=>{if(b&&typeof b=="string"&&b.startsWith("http"))return`background-image: url(${b});`;if(M){const _=String(M);return _.startsWith("#")?`background-color: ${_};`:`background-color: ${_.toLowerCase()};`}else return"background-color: #cccccc;"},q=()=>n`
        <a
          href="${a}"
          class="swatch"
          title="${m||e.title}"
          style="${y(f,m)}"
        ></a>
      `,S=w.slice(0,4).map(b=>{var K,X;const M=(X=(K=b.metafields)==null?void 0:K.colour)==null?void 0:X.swatch,_=b.handle.split("-").pop();return n`
        <a
          href="${b.url}"
          class="swatch"
          title="${_}"
          style="${y(M,_)}"
        ></a>
      `});return n`
      <div class="swatches">
        <!-- Current product swatch -->
        ${q()}
        <!-- Sibling product swatches -->
        ${S}
      </div>
    `},I=(W=e.variants)!=null&&W.length?e.variants.slice().sort((f,m)=>f.price-m.price)[0]:null;return n`
    <product-block
      class="product-block"
      data-product-id="${e.id}"
      data-in-carousel="${i?"true":"false"}"
    >
      <div class="block-inner" data-cc-animate="">
        <div class="block-inner-inner">
          ${e.images&&e.images.length>0?n`
                <div class="image-cont ${c?"image-cont--with-secondary-image":""}">
                  <a class="product-link" href="${a}" aria-hidden="true" tabindex="-1">
                    <div class="image-label-wrap">
                      ${de(e,I,n,l)}
                      <div
                        class="swiper product-block-swiper js-product-block-swiper"
                        data-product-id="${e.id}"
                        data-model-view-index="0"
                        data-product-view-index="${v-1}"
                        data-hover-index="1"
                        data-total-images="${v}"
                      >
                        <div class="swiper-wrapper">${A()}</div>

                        ${F()}
                      </div>
                    </div>
                  </a>
                  ${h?R():null}
                </div>
              `:null}

          <div class="product-block__detail align-ltr-${u}">
            <div class="inner">
              <div class="innerer">
                <a class="product-link" href="${a}">
                  ${d&&e.vendor?n` <div class="vendor">${e.vendor}</div> `:null}

                  <div class="product-block__heading">
                    <div class="product-block__title">${e.title}</div>
                  </div>

                  ${p&&((z=(D=e.metafields)==null?void 0:D.descriptors)!=null&&z.subtitle)?n` <div class="product-block__subtitle">${e.metafields.descriptors.subtitle}</div> `:null}
                </a>

                <div class="product-block-items-wrapper">
                  <a class="product-link" href="${a}">
                    <div class="product-price product-price--block">
                      ${s.isStorefrontAPICallPending()?n` <span class="skeleton-box"></span> `:n`
                            <span class="price ${T()?"price--on-sale":""}">
                              ${T()?n`
                                    <span class="price__sale">
                                      <span class="price__current">${k(e.price)}</span>
                                      <span class="price__was">${k(e.compare_at_price)}</span>
                                    </span>
                                  `:n` <span class="price__current">${k(e.price)}</span> `}
                            </span>
                          `}
                    </div>
                  </a>

                  <!-- Desktop swatches -->
                  <div class="product-block__swatches">${O()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </product-block>
  `};TagalysCustomisations.productBasedWidgetUtilities={onSuccessfulAPICall:async function(n,o){if(!n.products||!Array.isArray(n.products))return n;const t=await se(n.products);return n.products=n.products.map(e=>{const s=t[e.id];return s&&s.length>0&&(e.metafields||(e.metafields={}),e.metafields.colour||(e.metafields.colour={}),e.metafields.colour.variations||(e.metafields.colour.variations={}),e.metafields.colour.variations.items=s),e}),n},getRecommendationId:function(n){var e,s;const o=((e=window.theme)==null?void 0:e.settings)||{};return(((s=window.theme)==null?void 0:s.tagalysSettings)||{})[n]||o[n]||null},getTagalysSettings:function(n,o){var e;return(((e=window.theme)==null?void 0:e.tagalysSettings)||{})[n]||o},getRecommendationConfig:function(n,o={}){const t={recommendationId:n,callbacks:{onSuccessfulAPICall:async function(e,s){return await TagalysCustomisations.productBasedWidgetUtilities.onSuccessfulAPICall(e,s)}},templates:{widget:TagalysCustomisations.productBasedWidgetUtilities.getWidgetTemplate(o.widget||{}),loader:TagalysCustomisations.productBasedWidgetUtilities.getLoaderTemplate(),header:TagalysCustomisations.productBasedWidgetUtilities.getHeaderTemplate(),products:TagalysCustomisations.productBasedWidgetUtilities.getProductsTemplate(o.inCarousel||!1),product:TagalysCustomisations.productBasedWidgetUtilities.getProductTemplate()},...o};return o.widget&&delete o.widget,t},getWidgetTemplate:function(n={}){const o={},t={includeTagalysCSS:!1,count:16,displayFormat:"carousel",carouselOptions:{perPage:{300:2,600:3,768:4},duration:200,easing:"ease-out",startIndex:0,draggable:!0,onChange:function(e){}}};return{labels:{...o,...n.labels||{}},options:{...t,...n.options||{}},render:function(e,s){var i=s.props,r=i.helpers,a=r.getProducts(),l=this.options.displayFormat;if(i.loading===!1)return a.length===0?null:l==="carousel"?e`
              <div class="container container--not-mobile container--no-max tagalys-recommendations-container">
                <carousel-slider class="carousel block collection-slider">
                  <${s.templates.header} />
                  <${s.templates.products} />
                </carousel-slider>
              </div>
            `:e`
            <div class="container container--not-mobile container--no-max">
              <${s.templates.header} />
              <${s.templates.products} />
            </div>
          `}}},getLoaderTemplate:function(){return{render:function(n,o){return n`<div class="loading-spinner"></div>`}}},getHeaderTemplate:function(){return{render:function(n,o){var t=o.labels||{},e=t.heading,s=t.buttonText||null,i=t.buttonLink||null;if(!e&&window._tagalysParentLabels&&window._tagalysParentLabels.searchResults&&(e=window._tagalysParentLabels.searchResults.noResultsHeading),!e){var r=o.props.helpers.getAPIResponse();e=r==null?void 0:r.title}e||(e="Recommended for you");var a=o.props.helpers.getTemplateOptions("widget").displayFormat;return n`<h2
            class="hometitle h4 align-center has-paging ${a==="carousel"?"slider-nav":""}"
          >
            ${a==="carousel"?n`<button name="prev" class="slider-nav__btn has-ltr-icon">
                  <span class="visually-hidden">Previous</span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon feather feather-chevron-left"
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                  >
                    <path d="m15 18-6-6 6-6" />
                  </svg>
                </button>`:""}
            <span class="has-paging__title">${e}</span>
            ${a==="carousel"?n`<button name="next" class="slider-nav__btn has-ltr-icon">
                  <span class="visually-hidden">Next</span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon feather feather-chevron-right"
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                  >
                    <path d="m9 18 6-6-6-6" />
                  </svg>
                </button>`:""}
          </h2>
          ${s&&i?n`<div class="view-all align-center">
                <a class="small-feature-link" href="${i}">${s}</a>
              </div>`:""}`}}},getProductsTemplate:function(n=!1){return{render:function(o,t){var e=t.props,s=e.helpers.getProducts(),i=e.helpers.getTemplateOptions("widget").displayFormat;return o`
          <div
            class="collection-listing ${i==="carousel"?"slider slider--edge-peek slider--mobile-container-pad slider--no-scrollbar":""}"
          >
            <div
              class=${`product-grid product-grid--per-row-4 product-grid--per-row-mob-1 ${i==="carousel"?"slider__grid product-grid--carousel":""} ${e.className||""}`}
            >
              ${s.map((r,a)=>o`<div class="slider__item" key=${r.id}>
                  <${t.templates.product} product=${r} inCarousel=${n} />
                </div> `)}
            </div>
          </div>
        `},callbacks:{afterInitialRender:function(o){setTimeout(()=>{x(),C()},50)},afterEveryRender:function(o){setTimeout(()=>{x(),C()},50)}}}},getProductTemplate:function(){return{render:U}}};
